"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Font300Style = void 0;
const styled_components_1 = require("styled-components");
const commonUrl_1 = require("../../resource/commonUrl");
const DefaultGlobalStyle = (0, styled_components_1.createGlobalStyle) `
  * {
    font-family: "Noto Sans KR", -apple-system, Roboto,'Open Sans', sans-serif;
    font-style: normal;
  }

  img {
    user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;

    pointer-events: none;
  }

  @font-face {
    font-family: "Noto Sans KR";
    font-style: normal;
    font-weight: normal;
    src: url(${commonUrl_1.NotoSansFonts.regular400.woff2}) format("woff2"),
      url(${commonUrl_1.NotoSansFonts.regular400.woff}) format("woff"),
      url(${commonUrl_1.NotoSansFonts.regular400.otf}) format("truetype");
    font-display: swap;
  }

  @font-face {
    font-family: "Noto Sans KR";
    font-style: normal;
    font-weight: 500;
    src: url(${commonUrl_1.NotoSansFonts.medium500.woff2}) format("woff2"),
      url(${commonUrl_1.NotoSansFonts.medium500.woff}) format("woff"),
      url(${commonUrl_1.NotoSansFonts.medium500.otf}) format("truetype");
    font-display: swap;
  }

  @font-face {
    font-family: "Noto Sans KR";
    font-style: normal;
    font-weight: bold;
    src: url(${commonUrl_1.NotoSansFonts.bold700.woff2}) format("woff2"),
      url(${commonUrl_1.NotoSansFonts.bold700.woff}) format("woff"),
      url(${commonUrl_1.NotoSansFonts.bold700.otf}) format("truetype");
    font-display: swap;
  }
`;
exports.Font300Style = (0, styled_components_1.createGlobalStyle) `
  @font-face {
    font-family: "Noto Sans KR";
    font-style: normal;
    font-weight: 300;
    src: url(${commonUrl_1.NotoSansFonts.light300.woff2}) format("woff2"),
      url(${commonUrl_1.NotoSansFonts.light300.woff}) format("woff"),
      url(${commonUrl_1.NotoSansFonts.light300.otf}) format("truetype");
    font-display: swap;
  }
`;
exports.default = DefaultGlobalStyle;
